import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getHealthSafetyRestrictionsList(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query !== undefined
        ? apiUrl + "/opa-health-safety-restrictions" + actions.query
        : actions.page !== undefined
          ? apiUrl + "/opa-health-safety-restrictions?page=" + actions.page
          : apiUrl + "/opa-health-safety-restrictions?page_size=1000";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({
      type: "LIST_HEALTH_SAFETY_RESTRICTIONS_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "LIST_HEALTH_SAFETY_RESTRICTIONS_RESPONSE_GET",
      value: error,
    });
  }
}

function* getHealthSafetyRestriction(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-health-safety-restriction/"
        : apiUrl +
        "/opa-health-safety-restriction/" +
        actions.query +
        "?include=products";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({ type: "HEALTH_SAFETY_RESTRICTION_RESPONSE_GET", value: error });
  }
}

function* addHealthSafetyRestriction(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-health-safety-restriction";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_RESPONSE_ADD",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* editHealthSafetyRestriction(actions) {

  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url =
      apiUrl + "/opa-health-safety-restriction/" + actions.restrictionUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);
    let responseStatus = "warning";

    if (response) {
      if (response.updatedAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_RESPONSE_EDIT",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_RESPONSE_EDIT",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* deleteHealthSafetyRestriction(actions) {

  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      apiUrl + "/opa-health-safety-restriction/" + actions.restrictionUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);
    let responseStatus = "warning";

    if (response) {
      if (response.status === 204 || response.status === 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* addHealthSafetyRestrictionProduct(actions) {

  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.restrictionFormData),
    };

    let url =
      apiUrl +
      "/opa-health-safety-restriction/" +
      actions.form.restrictionUuid +
      "/products";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);
    let responseStatus = "warning";

    if (response) {
      if (Array.isArray(response) || response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_PRODUCT_RESPONSE_ADD",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_PRODUCT_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* deleteHealthSafetyRestrictionProducts(actions) {

  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.payload.restrictionFormData),
    };

    let url =
      apiUrl +
      "/opa-health-safety-restriction/" +
      actions.restrictionUuid +
      "/products";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);
    let responseStatus = "warning";

    if (response) {
      if (response.status === 204 || response.status === 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_PRODUCTS_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_PRODUCTS_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getProductHealthSafetyRestrictionsList(actions) {

  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      apiUrl + "/opa-product-health-safety-restrictions/" + actions.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "PRODUCT_HEALTH_SAFETY_RESTRICTIONS_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "PRODUCT_HEALTH_SAFETY_RESTRICTIONS_RESPONSE_GET",
      value: error,
    });
  }
}

function* getProductHealthSafetyRestriction(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      apiUrl +
      "/opa-product-health-safety-restriction/" +
      actions.productUuid +
      "/" +
      actions.restrictionUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "PRODUCT_HEALTH_SAFETY_RESTRICTION_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "PRODUCT_HEALTH_SAFETY_RESTRICTION_RESPONSE_GET",
      value: error,
    });
  }
}

function* addProductHealthSafetyRestrictions(actions) {

  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.healthSafetyRestrictionUuids),
    };

    let url =
      apiUrl +
      "/opa-product-health-safety-restrictions/" +
      actions.form.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);
    let responseStatus = "warning";

    if (response) {
      if (Array.isArray(response) || response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "HEALTH_SAFETY_RESTRICTIONS_PRODUCT_RESPONSE_ADD",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_PRODUCT_RESPONSE_ADD",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* deleteProductHealthSafetyRestrictions(actions) {

  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.healthSafetyRestrictionUuids),
    };

    let url =
      apiUrl +
      "/opa-product-health-safety-restrictions/" +
      actions.form.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);
    let responseStatus = "warning";

    if (response) {
      if (response.status === 204 || response.status === 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "HEALTH_SAFETY_RESTRICTIONS_PRODUCT_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "HEALTH_SAFETY_RESTRICTION_PRODUCT_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}
export function* getSagaHealthSafetyRestrictionsList() {
  yield takeEvery(
    "GET_LIST_HEALTH_SAFETY_RESTRICTIONS",
    getHealthSafetyRestrictionsList
  );
}

export function* getSagaHealthSafetyRestriction() {
  yield takeEvery("GET_HEALTH_SAFETY_RESTRICTION", getHealthSafetyRestriction);
}

export function* addSagaHealthSafetyRestriction() {
  yield takeEvery("ADD_HEALTH_SAFETY_RESTRICTION", addHealthSafetyRestriction);
}

export function* editSagaHealthSafetyRestriction() {
  yield takeEvery(
    "EDIT_HEALTH_SAFETY_RESTRICTION",
    editHealthSafetyRestriction
  );
}

export function* deleteSagaHealthSafetyRestriction() {
  yield takeEvery(
    "DELETE_HEALTH_SAFETY_RESTRICTION",
    deleteHealthSafetyRestriction
  );
}

export function* addSagaHealthSafetyRestrictionProduct() {
  yield takeEvery(
    "ADD_HEALTH_SAFETY_RESTRICTION_PRODUCT",
    addHealthSafetyRestrictionProduct
  );
}

export function* deleteSagaHealthSafetyRestrictionProducts() {
  yield takeEvery(
    "DELETE_HEALTH_SAFETY_RESTRICTION_PRODUCTS",
    deleteHealthSafetyRestrictionProducts
  );
}

export function* getSagaProductHealthSafetyRestrictionsList() {
  yield takeEvery(
    "GET_PRODUCT_HEALTH_SAFETY_RESTRICTIONS",
    getProductHealthSafetyRestrictionsList
  );
}

export function* getSagaProductHealthSafetyRestriction() {
  yield takeEvery(
    "GET_PRODUCT_HEALTH_SAFETY_RESTRICTION",
    getProductHealthSafetyRestriction
  );
}

export function* addSagaProductHealthSafetyRestrictions() {
  yield takeEvery(
    "ADD_PRODUCT_HEALTH_SAFETY_RESTRICTIONS",
    addProductHealthSafetyRestrictions
  );
}

export function* deleteSagaProductHealthSafetyRestrictions() {
  yield takeEvery(
    "DELETE_PRODUCT_HEALTH_SAFETY_RESTRICTIONS",
    deleteProductHealthSafetyRestrictions
  );
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
